const Server = () => {
    return (
        <>
            Server
        </>
    )

};

export default Server;